<template>
  <div>
    <div class="row">
      <div class="column medium-6 p-R-10">
        <div class="box general-settings">
          <div class="row m-B-10">
            <div class="column medium-6 p-R-10">
              <div class="data-field">
                <div class="label">Service Name (Backoffice Label) <span class="required">*</span></div>
                <input type="text" :class="{'input':true, 'has-error':!!errors.label }"
                  v-model="details.label" :disabled="saving" />
                <span class="error-msg">{{ errors.label }}</span>
              </div>
            </div>
            <div class="column medium-6">
              <div class="data-field">
                <div class="label">Service ID</div>
                <input type="text" class="input" :value="details.id" :disabled="true" readonly />
                <span class="error-msg">{{ errors.label }}</span>
              </div>
            </div>
          </div>

          <div class="row m-B-10">
            <div class="column medium-6 p-R-10">
              <div class="data-field">
                <div class="label">Service Code <span class="required">*</span></div>
                <input type="text" :class="{'input':true, 'has-error':!!errors.code }"
                  v-model="details.code" :disabled="saving" />
                <span class="error-msg">{{ errors.code }}</span>
              </div>
            </div>
            <div class="column medium-6">
              <div class="data-field">
                <div class="label">Color <span class="required">*</span></div>
                <input type="text" :class="{'input':true, 'has-error':!!errors.color }"
                  @click="showColor = true" @focus="showColor = true" v-model="details.color"
                  :disabled="saving" />
                <div class="palette" v-bind:style="{ background: details.color }" v-if="!!details.color"></div>
                <transition name="slide-down">
                  <div class="color-picker right" v-show="showColor">
                    <photoshop-picker v-model="colors" @ok="selectColor()" @cancel="showColor = false"></photoshop-picker>
                  </div>
                </transition>
                <span class="error-msg">{{ errors.color }}</span>
              </div>
            </div>
          </div>

          <div class="row m-B-10">
            <div class="column medium-6 p-R-10">
              <div class="service-types m-B-10">
                <div class="data-field">
                  <div class="label">License Type <span class="required">*</span></div>
                  <label class="radio-option">
                    <input type="checkbox" v-model="details.allowTNC" :disabled="saving" /> TNC
                  </label>
                  <label class="radio-option">
                    <input type="checkbox" v-model="details.allowTCP" :disabled="saving" /> TCP
                  </label>
                  <label class="radio-option">
                    <input type="checkbox" v-model="details.allowPSC" :disabled="saving" /> PSC
                  </label>
                  <span class="error-msg">{{ errors.licenseType }}</span>
                </div>
              </div>
              <div class="data-field">
                <div class="label">Default Tip</div>
                <div class="tip-input">
                  <span>%</span>
                  <input type="text" :class="{'input':true, 'has-error':!!errors.defaultTip }"
                    v-model="details.defaultTip" :disabled="saving" v-on:keypress="isNumber" />
                </div>
                <span class="error-msg">{{ errors.defaultTip }}</span>
              </div>
            </div>
            <div class="column medium-6">
              <div class="data-field check-item">
                <label :class="['label', {disabled:details.isCharter}]">
                  <input type="checkbox" v-model="details.isShared" :disabled="details.isCharter" /> Shared Ride Enable
                </label>
              </div>
              <div class="data-field check-item">
                <label class="label">
                  <input type="checkbox" v-model="details.poolP2P" /> Pool P2P
                </label>
              </div>
              <div class="data-field check-item">
                <label class="label">
                  <input type="checkbox" v-model="details.poolFromAirport" /> Pool from Airport
                </label>
              </div>
              <div class="data-field check-item">
                <label class="label">
                  <input type="checkbox" v-model="details.poolToAirport" /> Pool to Airport
                </label>
              </div>
              <div class="data-field check-item">
                <label class="label">
                  <input type="checkbox" v-model="details.useShifts" /> Driver Availability Enable
                </label>
              </div>
              <div class="data-field check-item">
                <label class="label">
                  <input type="checkbox" v-model="details.isCharter" /> Charter Service
                </label>
              </div>
              <div class="data-field check-item" style="height:20px">
                <label :class="['label', {disabled:details.isCharter || details.isShared}]">
                  <input type="checkbox" v-model="details.optinAllow" :disabled="details.isCharter || details.isShared" /> Offer as Opt-in Service
                </label>
              </div>
              <div class="data-field optin-discount" v-if="details.optinAllow">
                <div class="label">Opt-in Discount</div>
                <div class="input-integer">
                  <input type="number" v-model="details.optinPercent" :disabled="!details.optinAllow || details.isShared || saving" />
                  <span>percent</span>
                </div>
              </div>
              <div class="data-field check-item" >
                <label class="label">
                  <input type="checkbox" v-model="details.isRental"  /> Rental Service
                </label>
                <input type="text" class="sub-val" v-model="details.maxConcurrent" placeholder="Max Concurrent" />
              </div>
            </div>
          </div>

          <div class="row m-B-10">
            <div class="column medium-4">
              <div class="data-field m-B-10">
                <div class="label">Admin Booking Buffer</div>
                <div class="input-integer">
                  <input type="number" v-model="details.bufferAdminMins" :disabled="saving" />
                  <span>minutes</span>
                </div>
              </div>
            </div>
            <div class="column medium-4">
              <div class="data-field m-B-10">
                <div class="label">Web Booking Buffer</div>
                <div class="input-integer">
                  <input type="number" v-model="details.bufferWidgetMins" :disabled="saving" />
                  <span>minutes</span>
                </div>
              </div>
            </div>
            <div class="column medium-4">
              <div class="data-field m-B-10">
                <div class="label">App Booking Buffer</div>
                <div class="input-integer">
                  <input type="number" v-model="details.bufferAppMins" :disabled="saving" />
                  <span>minutes</span>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="row m-B-10">
            <div class="column medium-6">
              <div class="data-field">
                <label class="label"><input type="checkbox" v-model="allowedTime" /> Allowed Time</label>
                <VueCtkDateTimePicker v-model="timeStart" :disabled="!allowedTime"
                  :format="timeOptions.format" :formatted="timeOptions.formatted"
                  :only-time="timeOptions.onlyTime" :no-label="timeOptions.noLabel"
                  :label="timeOptions.label" :color="timeOptions.color"
                  :minute-interval="timeOptions.minuteInterval" :id="timeOptions.id"
                ></VueCtkDateTimePicker>
              </div>
            </div>
            <div class="column medium-6">
              <div class="data-field no-label">
                <VueCtkDateTimePicker v-model="timeEnd" :disabled="!allowedTime"
                  :format="timeOptions.format" :formatted="timeOptions.formatted"
                  :only-time="timeOptions.onlyTime" :no-label="timeOptions.noLabel"
                  :label="timeOptions.label" :color="timeOptions.color"
                  :minute-interval="timeOptions.minuteInterval" :id="timeOptions.id"
                ></VueCtkDateTimePicker>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <div class="column medium-6 p-L-10">
        <div class="box">
          <div class="row m-B-10">
            <div class="column medium-6 end">
              <div class="data-field">
                <label class="label">
                  <input type="checkbox" v-model="subscription" :disabled="saving" /> Subscription
                </label>
                <!-- <span class="error-msg">{{ validation.basicInfo.firstName }}</span> -->
              </div>
            </div>
          </div>
          <div class="row m-B-10">
            <div class="column medium-12">
              <div class="data-field">
                <div class="label">Price</div>
                <input type="text" class="input" :disabled="!subscription || saving" />
                <!-- <span class="error-msg">{{ validation.basicInfo.firstName }}</span> -->
              </div>
            </div>
          </div>
          <div class="row m-B-10">
            <div class="column medium-6">
              <div class="data-field">
                <div class="label">Billing Interval</div>
                <select :disabled="!subscription || saving">
                  <option>Weekly</option>
                  <option>Monthly</option>
                </select>
                <!-- <span class="error-msg">{{ validation.basicInfo.firstName }}</span> -->
              </div>
            </div>
            <div class="column medium-6">
              <div class="data-field">
                <div class="label">Trial Period</div>
                <input type="text" class="input" :disabled="!subscription || saving" />
                <!-- <span class="error-msg">{{ validation.basicInfo.firstName }}</span> -->
              </div>
            </div>
          </div>

          <div class="row m-B-10 m-T-20 top-line">
            <div class="column medium-6 end">
              <div class="data-field">
                <label class="label">
                  <input type="checkbox" v-model="hourlyRate" :disabled="saving" /> Hourly Rate
                </label>
                <!-- <span class="error-msg">{{ validation.basicInfo.firstName }}</span> -->
              </div>
            </div>
          </div>
          <div class="row m-B-10">
            <div class="column medium-6">
              <div class="data-field">
                <div class="label">Per Hour Price</div>
                <input type="text" class="input" :disabled="!hourlyRate || saving" />
                <!-- <span class="error-msg">{{ validation.basicInfo.firstName }}</span> -->
              </div>
            </div>
            <div class="column medium-6">
              <div class="data-field">
                <div class="label">Succeeding Hours</div>
                <input type="text" class="input" :disabled="!hourlyRate || saving" />
                <!-- <span class="error-msg">{{ validation.basicInfo.firstName }}</span> -->
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="brand-box">
      <div class="body">
        <div class="row">
          <div class="column medium-4 img-upload">
            <div class="active-image image-box">
              <div class="data-field">
                <div class="label">Active Image</div>
              </div>
              <div @click="triggerClickUpload('uploadImg')"
                :class="{'img-box': true, 'loading': uploadingImg, 'has-error':!!errors.imgUrl}">
                <img :src="imgUrl" v-if="imgUrl">
                <i class="fa fa-image" v-else></i>
                <div class="loader" v-show="uploadingImg">
                  <i class="fas fa-spinner fa-spin"></i>
                  Uploading image...
                </div>
                <div class="recommened">Recommended size: 300x300</div>
              </div>
              <input type="file" ref="uploadImg" v-show="false" @change="uploadImg($event, 'Img')" accept="image/*"/>
              <span class="error-msg">{{errors.imgUrl}}</span>
              <a class="button cta xsmall block error" @click="triggerClickUpload('uploadImg')">Upload Image</a>
            </div>
            <input type="file" ref="uploadImg" v-show="false"
              @change="uploadImg($event, 'Img')" accept="image/*"/>
            <span class="error-msg">{{errors.imgUrl}}</span>
            <a class="button cta xsmall block error" v-if="false"
              @click="triggerClickUpload('uploadImg')">Upload Image</a>

            <div class="inactive-image image-box">
              <div class="data-field">
                <div class="label">Inactive Image</div>
              </div>
              <div @click="triggerClickUpload('uploadImgOff')"
                :class="{'img-box': true, 'loading': uploadingImgOff, 'has-error':!!errors.imgOffUrl}">
                <img :src="imgOffUrl" v-if="imgOffUrl">
                <i class="fa fa-image" v-else></i>
                <div class="loader" v-show="uploadingImgOff">
                  <i class="fas fa-spinner fa-spin"></i>
                  Uploading image...
                </div>
                <div class="recommened">Recommended size: 300x300</div>
              </div>
              <input type="file" ref="uploadImgOff" v-show="false"
                @change="uploadImg($event, 'ImgOff')" accept="image/*"/>
              <span class="error-msg">{{errors.imgOffUrl}}</span>
              <a class="button cta xsmall block error"
                @click="triggerClickUpload('uploadImgOff')">Upload Image</a>
            </div>
          </div>
          <div class="column medium-8">

            <div class="row m-B-10">
              <div class="column medium-6">
                <div class="data-field">
                  <div class="label">Service Name <span class="required">*</span></div>
                  <input type="text" :class="{'input':true, 'has-error':!!errors.name }"
                    v-model="details.name" :disabled="saving" />
                  <span class="error-msg">{{ errors.name }}</span>
                </div>
              </div>
              <div class="column medium-3 pax">
                <div class="data-field">
                  <div class="label">Max Passenger <span class="required">*</span></div>
                  <vue-autonumeric v-model="details.maxPassengers" :options="passenger"
                    :class="{'input':true, 'has-error':!!errors.maxPassengers }"
                    :disabled="saving"></vue-autonumeric>
                  <span class="error-msg">{{ errors.maxPassengers }}</span>
                </div>
              </div>
              <div class="column medium-3">
                <div class="data-field">
                  <div class="label">Max Luggage <span class="required">*</span></div>
                  <vue-autonumeric v-model="details.maxLuggages" :options="luggage"
                    :class="{'input':true, 'has-error':!!errors.maxLuggages }"
                    :disabled="saving"></vue-autonumeric>
                  <span class="error-msg">{{ errors.maxLuggages }}</span>
                </div>
              </div>
            </div>

            <div class="sub-box">
              <div class="heading m-B-10">Web Form</div>

              <div class="row m-B-10">
                <div class="column medium-12">
                  <div class="data-field">
                    <div class="label">Description - Excerpt <span class="required">*</span></div>
                    <textarea :class="{'has-error':!!errors.excerptWeb }"
                      v-model="details.excerptWeb" :disabled="saving"></textarea>
                    <span class="error-msg">{{ errors.excerptWeb }}</span>
                  </div>
                </div>
              </div>

              <div class="row m-B-10">
                <div class="column medium-12">
                  <div class="data-field">
                    <div class="label">Description - Full <span class="required">*</span></div>
                    <textarea :class="{'has-error':!!errors.descriptionWeb }"
                      v-model="details.descriptionWeb" :disabled="saving"></textarea>
                    <span class="error-msg">{{ errors.descriptionWeb }}</span>
                  </div>
                </div>
              </div>

              <div class="row m-B-10">
                <div class="column medium-6">
                  <div class="data-field">
                    <div class="label">Description - Advantage</div>
                    <input type="text" class="input" v-model="details.advantageWeb"
                      :disabled="saving"/>
                    <!-- <span class="error-msg">{{ validation.basicInfo.firstName }}</span> -->
                  </div>
                </div>
                <div class="column medium-6">
                  <div class="data-field">
                    <div class="label">Description - Stops</div>
                    <input type="text" class="input" v-model="details.stops"
                      :disabled="saving"/>
                    <!-- <span class="error-msg">{{ validation.basicInfo.firstName }}</span> -->
                  </div>
                </div>
              </div>
            </div>

            <div class="sub-box">
              <div class="heading m-B-10">Consumer App</div>

              <div class="row m-B-10">
                <div class="data-field">
                  <div class="label">Service Category <span class="required">*</span></div>
                  <span class="note">For best customer viewing experience, please specify only up to three service types in each category</span>
                  <input type="text" :class="{'input':true, 'has-error':!!errors.category }"
                    v-model="details.category" :disabled="saving"/>
                  <span class="error-msg">{{ errors.category }}</span>
                </div>
              </div>

              <div class="row m-B-10">
                <div class="data-field">
                  <div class="label">Description - Excerpt <span class="required">*</span></div>
                  <textarea :class="{'has-error':!!errors.excerptApp }"
                    v-model="details.excerptApp" :disabled="saving"></textarea>
                  <span class="error-msg">{{ errors.excerptApp }}</span>
                </div>
              </div>

              <div class="row m-B-10">
                <div class="data-field">
                  <div class="label">Description - Slogan <span class="required">*</span></div>
                  <input type="text" :class="{'input':true, 'has-error':!!errors.slogan }"
                    v-model="details.slogan" :disabled="saving" />
                  <span class="error-msg">{{ errors.slogan }}</span>
                </div>
              </div>

              <div class="row m-B-10">
                <div class="data-field">
                  <div class="label">Description - Full<span class="required">*</span></div>
                  <textarea :class="{'has-error':!!errors.descriptionApp }"
                    v-model="details.descriptionApp" :disabled="saving"></textarea>
                  <span class="error-msg">{{ errors.descriptionApp }}</span>
                </div>
              </div>

              <div class="row m-B-10">
                <div class="data-field">
                  <div class="label">Description - Advantage</div>
                  <input type="text" class="input" v-model="details.advantageApp"
                    :disabled="saving"/>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="column medium-6 p-R-10">
        <div class="box">
          <div class="data-field" style="padding-left: 0">
            <div class="label" style="margin-bottom: 3px;">Disabled on dates</div>
            <div class="group-field">
              <datepicker :format="calendarFormat" input-class="datepicker m-T-0" class="datepicker"
                v-model="disabledDate" :disabled-picker="saving" placeholder="Select Date"
                calendar-button-icon="fa fa-calendar" :calendar-button="true"
                :disabled="disabledDates" calendar-class="top-calendar"></datepicker>
              <a class="button cta" @click="addDisabledDate">ADD</a>
            </div>
          </div>

          <transition name="slide-down">
            <ul class="disabled-list" v-if="unavailableTimes.length">
              <li v-for="(dates, i) in unavailableTimes" :key="i">
                {{dates}}
                <a @click="removeDisabledDate(dates)">[ Remove ]</a>
              </li>
            </ul>
          </transition>
        </div>

        <div class="box">
          <div class="box-header">Service Unavailability</div>
          <div class="d-flex service-unavailable-options">
            <label>
              <input type="checkbox" v-model="serviceUnavailable.asap" />
              ASAP
            </label>
            <label>
              <input type="checkbox" v-model="serviceUnavailable.future" />
              Future
            </label>
          </div>
          <div class="d-flex service-unavailable-options">
            <label>
              <input type="checkbox" v-model="serviceUnavailable.p2p" />
              Point to Point
            </label>
            <label>
              <input type="checkbox" v-model="serviceUnavailable.fromAirport" />
              From Airport
            </label>
            <label>
              <input type="checkbox" v-model="serviceUnavailable.toAirport" />
              To Airport
            </label>
          </div>
          <div class="d-flex">
            <div class="data-field" style="padding-left: 0">
              <div class="label" style="margin-bottom: 3px;">Start Time</div>
              <div class="group-field">
                <select v-model="serviceUnavailable.startTime" class="time-select">
                  <option v-for="x in 24" :key="x" :value="x - 1">{{ leadingZero(x - 1) }}:00</option>
                </select>
              </div>
            </div>
            <div class="data-field" style="padding-left: 0">
              <div class="label" style="margin-bottom: 3px;">End Time</div>
              <div class="group-field">
                <select v-model="serviceUnavailable.endTime" class="time-select">
                  <option v-for="x in 24" :key="x" :value="x - 1">{{ leadingZero(x - 1) }}:00</option>
                </select>
                <!-- <a class="button cta smaller" @click="addServiceUnavailableDate">ADD</a> -->
              </div>
            </div>
          </div>

          <!-- <transition name="slide-down">
            <ul class="disabled-list" v-if="serviceUnavailableTimes.length">
              <li v-for="(dates, i) in serviceUnavailableTimes" :key="i">
                {{ dates.start }}:00 - {{ dates.end }}:00
                <a @click="removeServiceUnavailableTime(dates)">[ Remove ]</a>
              </li>
            </ul>
          </transition> -->
        </div>
      </div>

      <div class="column medium-6 p-R-10">
        <div class="box">
          <div class="data-field" style="padding-left: 0">
            <div class="label" style="margin-bottom: 3px;">More Images</div>
            <input type="file" ref="moreImages" v-show="false" multiple :disabled="moreImages.loading"
              @change="uploadMoreStart($event)" accept="image/*"/>
            <a :class="['button cta', {disabled: moreImages.loading}]" @click="triggerClickUpload('moreImages')">
              <span v-if="!moreImages.loading">
                <i class="fas fa-plus fa-fw"></i>
                Upload
              </span>
              <span v-else>
                <i class="fas fa-spinner fa-spin fa-fw"></i>
                Uploading...
              </span>
            </a>
          </div>

          <transition name="slide-down">
            <ul class="more-imgs" v-if="moreImgs && moreImgs.length">
              <li v-for="(img, i) in moreImgs" :key="i">
                <a class="link" :href="img" target="_blank">{{img}}</a>
                <a @click="removeMoreImg(img)" class="remove">[ Remove ]</a>
              </li>
            </ul>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiServices from '@/modules/api/services'

import moment from 'moment'
import { Photoshop } from 'vue-color'
// import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
// import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import VueAutonumeric from 'vue-autonumeric'
import datepicker from 'vuejs-datepicker'

let minuteNow = parseInt(moment().format('m'))
minuteNow = minuteNow % 5
minuteNow = minuteNow > 0 ?  5 - minuteNow : 0

export default {
  name: 'service-details',
  components: {'photoshop-picker': Photoshop, /*VueCtkDateTimePicker,*/ VueAutonumeric, datepicker },
  data () {
    return {
      colors: '',
      licenseType: '',
      allowedTime: false,
      // timeStart: moment().add(minuteNow, 'minutes').format('HH:mm'),
      // timeEnd: moment().add(minuteNow + 5, 'minutes').format('HH:mm'),
      timeStart: '',
      timeEnd: '',
      timeOptions: {
        format: 'HH:mm',
        formatted: 'HH:mm',
        onlyTime: true,
        color: '#0D79F2',
        minuteInterval: '5',
        label: 'Select time',
        id: 'TimePicker',
        noLabel: true
      },
      showColor: false,
      sharedRideEnable: false,
      subscription: false,
      hourlyRate: false,
      imgUrl: '',
      imgOffUrl: '',
      uploadingImg: false,
      uploadingImgOff: false,
      temp: {
        id: '',
        imgUrl: '',
        imgOffUrl: ''
      },
      passenger: {
        minimumValue: '1',
        maximumValue: '100',
        decimalPlaces: 0
      },
      luggage: {
        minimumValue: '0',
        maximumValue: '100',
        decimalPlaces: 0
      },
      errors: {
        label: '',
        code: '',
        color: '',
        licenseType: '',
        imgUrl: '',
        imgOffUrl: '',
        name: '',
        maxPassengers: '',
        maxLuggages: '',
        excerptWeb: '',
        descriptionWeb: '',
        category: '',
        excerptApp: '',
        descriptionApp: '',
        slogan: '',
        defaultTip: ''
      },
      today: moment(),
      disabledDate: '',
      serviceUnavailability: {
        p2p: false,
        fromAirport: false,
        toAirport: false,
        startTime: 0,
        endTime: 0
      },
      moreImages: {
        loading: false,
        uploads: []
      }
    }
  },
  computed: {
    services () { return this.$store.state.services },
    details () { return this.services.details },
    saving () { return this.services.saving },
    disabledDates () {
      if (this.today.format('MM') === '01') {
        return {
          to: new Date(
            this.today.subtract(1, 'months').format('YYYY'),
            this.today.format('MM'),
            this.today.format('DD')
          )
        }
      }

      return {
        to: new Date(
          this.today.format('YYYY'),
          this.today.subtract(1, 'months').format('MM'),
          this.today.format('DD')
        )
      }
    },
    unavailableTimes () { return this.details.unavailableTimes },
    moreImgs () { return this.details.images },
    serviceUnavailable () { return this.services.serviceUnavailable }
  },
  methods: {
    selectColor () {
      let color = this.colors.hex ? this.colors.hex.substring(1, this.colors.hex.length) : '000000'
      this.$store.commit('services/setDetailsData', {
        field: 'color',
        value: '#' + color
      })
      this.showColor = false
    },
    triggerClickUpload (ref) {
      if (this.saving) { return }
      this.$refs[ref].click()
    },
    uploadImg (e, target) {
      if (!e.target.files.length) { return }
      // this.uploadingImg = true
      this['uploading' + target] = true

      let self = this
      let file = e.target.files[0]
      let fd = new FormData()
      fd.append('pic', file)

      self.$http.post(CONFIG.mediaHost + '/api/upload', fd, {
        header: {'Content-Type': 'multipart/form-data'}
      }).then(function (res) {
        self['uploading' + target] = false 
        if (!res.body.success) {
          // self.$store.commit('provider/showUploadError', true)
        } else {
          if (target === 'ImgOff') {
            self.imgOffUrl = res.body.data.url
            self.$store.commit('services/setDetailsData', {
              field: 'imageOff',
              value: res.body.data.url
            })
            self.resetInputFile('uploadImgOff')
          } else {
            self.imgUrl = res.body.data.url
            self.$store.commit('services/setDetailsData', {
              field: 'image',
              value: res.body.data.url
            })
            self.resetInputFile('uploadImg')
          }
        }
      }, function (res) {
        console.log('error', res)
        // self.$store.commit('provider/showUploadError', true)
      })
    },
    resetInputFile (ref) {
      this.$refs[ref].type = 'text'
      this.$refs[ref].type = 'file'
    },
    validate () {
      let noError = true
      let requireFields = [
        'label', 'code', 'color',
        'name', 'excerptWeb', 'descriptionWeb',
        'excerptApp', 'descriptionApp', 'slogan',
        'category'
      ]

      this.errors = {
        label: '',
        code: '',
        color: '',
        licenseType: '',
        imgUrl: '',
        imgOffUrl: '',
        name: '',
        maxPassengers: '',
        maxLuggages: '',
        excerptWeb: '',
        descriptionWeb: '',
        category: '',
        excerptApp: '',
        descriptionApp: '',
        slogan: '',
        defaultTip: ''
      }

      requireFields.forEach(field => {
        if (this.details[field].trim() === '') {
          this.errors[field] = 'This field cannot be empty.'
          noError = false
        }
      })

      if (this.details.defaultTip < 0) {
        this.errors.defaultTip = 'Value cannot be less than zero'
      }

      // if (!this.licenseType) {
      //   noError = false
      //   this.errors.licenseType = 'Must select license type'
      // }
      if (!this.details.allowTNC && !this.details.allowTCP && !this.details.allowPSC) {
        noError = false
        this.errors.licenseType = 'Must select atleast 1 license type'
      }

      if (this.imgUrl.trim() === '') {
        noError = false
        this.errors.imgUrl = 'Please provide an image for this service'
      }
      if (this.imgOffUrl.trim() === '') {
        noError = false
        this.errors.imgOffUrl = 'Please provide an image for this service'
      }

      return noError
    },
    save () {
      let self = this
      if (!this.validate() || this.saving) { return }

      self.$store.commit('services/setSaving', true)
      ApiServices.addService(self, res => {
        self.$store.commit('services/setSaving', false)
        let response = {
          show: true,
          status: 'success',
          message: 'Successfully created a service!',
          extra: ''
        }
        if (res.error) {
          response.status = 'error'
          response.message = 'Oops! Something went wrong...'
          response.extra = res.error.message
        }
        self.$emit('response', response)
      })
    },
    update () {
      let self = this
      if (!this.validate() || this.saving) { return }

      self.$store.commit('services/setSaving', true)
      ApiServices.updateService(self, self.details, res => {
        self.$store.commit('services/setSaving', false)
        let response = {
          show: true,
          status: 'success',
          message: 'Successfully updated!',
          extra: ''
        }
        if (res.error) {
          response.status = 'error'
          response.message = 'Oops! Something went wrong...'
          response.extra = res.error.message
        }
        self.$emit('response', response)
      })
    },
    revalidate () {
      if (this.validate()) { this.$emit('revalidate') }
    },
    clone (brandId) {
      let self = this
      if (!this.validate() || this.saving) { return }

      self.$store.commit('services/setSaving', true)
      ApiServices.cloneService(self, brandId, res => {
        self.$store.commit('services/setSaving', false)
        let response = {
          show: true,
          brand: brandId,
          status: 'success',
          message: 'Clone Success!',
          extra: ''
        }
        if (res.error) {
          response.status = 'error'
          response.message = 'Oops! Something went wrong...'
          response.extra = res.error.message
        }
        self.$emit('clone', response)
      })
    },
    clearErrors () {
      this.errors = {
        label: '',
        code: '',
        color: '',
        licenseType: '',
        imgUrl: '',
        imgOffUrl: '',
        name: '',
        maxPassengers: '',
        maxLuggages: '',
        excerptWeb: '',
        descriptionWeb: '',
        category: '',
        excerptApp: '',
        descriptionApp: '',
        slogan: ''
      }
    },
    isNumber (evt) {
      let charCode = (evt.which) ? evt.which : evt.keyCode
      if (charCode === 46) { return true }
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault()
        return
      }
      return true
    },
    calendarFormat (date) { return moment(date).format('MM/DD/YYYY') },
    addDisabledDate () {
      if (!this.disabledDate) return

      let newVal = moment(this.disabledDate).format('MM/DD/YYYY')
      if (this.unavailableTimes.indexOf(newVal) === -1) {
        this.$store.commit('services/addUnavailableTimes', newVal)
        this.disabledDate = ''
      }
    },
    removeDisabledDate (x) {
      this.$store.commit('services/removeUnavailableTimes', x)
    },
    uploadMoreStart (e) {
      if (!e.target.files.length || this.moreImages.loading) return

      let self = this
      for (let i = 0; i < e.target.files.length; i++) {
        self.moreImages.uploads.push(e.target.files[i])
      }
      self.moreImages.loading = true
      self.processUploadMore()
    },
    processUploadMore () {
      let self = this
      if (!self.moreImages.uploads.length) {
        self.moreImages.loading = false 
        return
      }

      let fd = new FormData()
      fd.append('pic', self.moreImages.uploads[0])

      self.$http.post(CONFIG.mediaHost + '/api/upload', fd, {
        header: {'Content-Type': 'multipart/form-data'}
      }).then(function (res) {
        self.moreImages.uploads.shift()
        if (!res.body.success) {
        } else {
          self.$store.commit('services/addMoreImgs', res.body.data.url)
        }
        self.processUploadMore()
      }, function (res) {
        console.log('error', res)
        self.moreImages.uploads.shift()
        self.processUploadMore()
      })
    },
    removeMoreImg (x) {
      this.$store.commit('services/removeMoreImgs', x)
    },
    leadingZero (x) { return x < 10 ? '0' + x : x },
    // addServiceUnavailableDate () {
    //   this.$store.commit('services/toggleServiceUnavailableTimes', {
    //     start: this.serviceUnavailability.startTime,
    //     end: this.serviceUnavailability.endTime
    //   })
    // },
    // removeServiceUnavailableTime (x) {
    //   this.$store.commit('services/toggleServiceUnavailableTimes', {
    //     start: x.start,
    //     end: x.end
    //   })
    // }
  },
  watch: {
    details (value) {
      if (value) {
        if (value.id !== this.temp.id) {
          this.temp = {
            id: value.id,
            imgUrl: value.image,
            imgOffUrl: value.imageOff
          }
          this.imgUrl = value.image
          this.imgOffUrl = value.imageOff
        }
        this.colors = { hex: value.color }
        this.resetInputFile('moreImages')

        // if (value.allowTNC) {
        //   this.licenseType = 'TNC'
        // } else if (value.allowTCP) {
        //   this.licenseType = 'TCP'
        // } else if (value.allowPSC) {
        //   this.licenseType = 'PSC'
        // }
      }
    },
    licenseType (value) {
      // if (value) {
      //   this.$store.commit('services/setDetailsData', {field: 'allowTNC', value: false})
      //   this.$store.commit('services/setDetailsData', {field: 'allowTCP', value: false})
      //   this.$store.commit('services/setDetailsData', {field: 'allowPSC', value: false})

      //   this.$store.commit('services/setDetailsData', {field: 'allow' + value, value: true})
      //   this.$emit('fieldChange')
      // }
    },
    'details.isShared': function (val) {
      if (val) {
        this.details.optinAllow = false
      }
    },
    'details.isCharter': function (val) {
      if (val) {
        this.details.isShared = false
        this.details.optinAllow = false
      }
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>

.m-T-20{ margin-top: 20px; }
.m-B-10{ margin-bottom: 10px; }
.p-L-10{ padding-left: 10px; }
.p-R-10{ padding-right: 10px; }

.row{ max-width: 100%; }
.box{
  background: #fff;
  border-radius: 2px;
  border: 1px solid #b0c6e4;
  padding: 15px;
  box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);
  margin-bottom: 10px;

  .top-line{
    border-top: 1px solid #b0c6e4;
    padding-top: 10px;
  }
  .box-header{
    font-size: 21px;
    font-weight: 600;
    color: #555;
    margin-bottom: 10px;
  }
  input{
    display: inline-block;
    width: inherit;
  }
  .service-unavailable-options{
    gap: 20px;
    margin: 20px 0;

    label{
      color: #0D79F2;
      font-weight: 600;
      font-size: 11px;
      text-transform: uppercase;
      line-height: 130%;
      letter-spacing: .4px;

      input{
        vertical-align: -2px;
        margin: 0 3px 0 0;
      }
    }
  }
  .time-select{
    width: 100px;
    margin-top: 0;
  }
  .button.smaller{
    padding: 12px 20px 4px;
  }
}

// .general-settings{ height: 341px; }

.data-field{
  padding: 0 5px;
  position: relative;

  &.no-label{ padding-top: 24px; }
  input[type='checkbox'], input[type='radio']{
    width: inherit;
    display: inline-block;
    margin: 0 3px 0 0;
  }
  &.check-item label{
    height: 25px;
    display: block;
    
    &.disabled{
      color: #89a2be;
    }
  }
  &.optin-discount{
    padding-left: 24px;
    .label{
      color: #445568;
    }
  }
  .label{
    color: #0D79F2;
    font-weight: 600;
    font-size: 11px;
    text-transform: uppercase;
    line-height: 130%;

    &.bigger{ font-size: 14px; }
    input[type='checkbox']{ vertical-align: -2px; }
  }
  .note{
    font-size: 12.5px;
    color: #999;
    display: block;
  }
  .input{
    margin: 3px 0 0;
    color: #333;
    line-height: inherit;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
  }
  textarea{
    resize: vertical;
    margin: 3px 0 0;
  }
  .check-option{
    font-size: 14px;
    cursor: pointer;
    display: block;

    input{ vertical-align: -1px; }
  }
  .radio-option{
    font-size: 14px;
    cursor: pointer;
    display: block;
    margin: 5px 0;

    input{ vertical-align: -1px; }
  }
  .sub-val{
    margin: 0 0 20px 20px;
    line-height: 1;
    padding: 5px;
    font-size: 13px;
    width: calc(100% - 20px);
  }
  .has-error{ border-color: #f20d0d; }
  .error-msg{
    font-size: 11px;
    line-height: 1.6;
    color: #f20d0d;
    font-style: italic;
    display: block;
  }
}
select{
  margin-top: 5px;
  border: 1px solid #ddd;
  padding: 10px;
  color: #333;
  height: 45px;
  position: relative;
  font-size:14px;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url('/assets/img/dropdown-arrow.png');
  background-repeat: no-repeat;
  background-position: right 50%;
  transition: all .35s ease;

  &.has-error{ border-color: #f20d0d; }
  &:disabled{ background-color: #eee; }
}
.required{
  color: #f00;
  font-weight: 600;
  margin-left: 2px;
}
.tip-input{
  position: relative;

  span{
    position: absolute;
    top: 0;
    left: 10px;
    z-index: 2;
    line-height: 44px;
    font-weight: 600;
    color: #888;
  }
  input{
    padding-left: 30px;
  }
}
.input-integer {
  display: flex;
  & > * {
    display: inline-block;
    vertical-align: middle;
    margin-top: 0;
  }
  input[type="number"] {
    font-size: 16px;
    padding: 10px;
    display: inline-block;
    width: 100%;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  span {
    font-size: 13px;
    background-color: #555;
    color: #fff;
    padding: 10px;
    margin-left: -5px;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    line-height: 24px;
  }
}


.service-types{
  background: #fafafa;
  padding: 10px;
  margin-top: 5px;
  border: 1px solid #ccc;
  border-radius: 6px;
}

.brand-box{
  background: #fff;
  margin: 20px 0;
  box-shadow: 0px 0px 3px rgba(0,0,0, .2);
  border: 1px solid #b0c6e4;

  .body{ padding: 20px; }

  .img-upload{
    text-align: center;
    padding: 20px;

    .inactive-image{ margin-top: 30px; }
    .data-field{ padding: 0 0 5px; }
    .label{ text-align: left; }
    .img-box{
      background: #fafafa;
      border: 1px solid #555;
      margin-bottom: 28px;
      cursor: pointer;
      position: relative;
      text-align: center;

      &.loading{
        .fa-image, img { opacity: .4; }
      }
      img { width: 90%; }
      .recommened{
        position: absolute;
        top: 100%;
        left: -1px;
        width: calc(100% + 2px);
        font-size: 13px;
        font-weight: 600;
        line-height: 25px;
        background: #555;
        border: 1px solid #555;
        color:#fff;
      }
      &.has-error{
        border-color: #f20d0d;
        .recommened{
          border-color: #f20d0d;
          background: #f20d0d;
        }
      }
    }
    .fa-image{
      font-size: 120px;
      color: #becfd3;
      line-height: 100px;
      margin: 10px 0;
    }
    .loader{
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      font-size: 14px;
      font-weight: 600;
      color: #333;
      margin-top: -10px;

      i{
        font-size:21px;
        margin-right: 5px;
        vertical-align: middle
      }
    }
    .error-msg{
      font-size: 13px;
      line-height: 1.6;
      color: #f20d0d;
      font-style: italic;
      display: block;
    }
    .button{
      max-width: 400px;
      margin-top: 15px;
    }
  }
  .sub-box{
    border: 1px solid #ccc;
    margin: 0 5px 10px;
    padding: 15px;
    background: #fafafa;

    .heading{
      padding: 0 5px;
      font-size: 21px;
      font-weight: 600;
      color: #555;
    }
  }
}

.palette{
  position: absolute;
  top: 30px;
  right: 14px;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  border: 1px solid #333;
}
.color-picker{
  position: absolute;
  top: 100%;
  z-index: 3;
  transform-origin: top center;

  &.right{ right: 0; }
  &.left{ left: 0; }
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .3s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}

.group-field{
  display: flex;

  .button{
    margin-left: 10px;
  }
}

.disabled-list{
  list-style: none;
  margin: 10px 0 0;
  padding: 10px;
  font-size: 14px;
  background: #fafafa;
  border: 1px solid #ccc;
  column-count: 2;

  li{
    margin: 3px 0;
  }
  a{
    font-weight: 600;
    cursor: pointer;
    margin-left: 5px;

    &:hover{
      text-decoration: underline;
    }
  }
}
.more-imgs{
  list-style: none;
  margin: 10px 0 0;
  font-size: 14px;
  padding: 0;
  background: #f8f8f8;
  border: 1px solid #ccc;

  li{
    padding: 10px;
    border-bottom: 1px solid #ddd;
    display: flex;
    justify-content: space-between!important;

    &:hover{
      background: #fcfcfc;
    }
  }
  .link{
    display: block;
    width: calc(100% - 100px);
    color: #555;
    text-decoration: underline;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .remove{
    font-weight: 600;
    cursor: pointer;
    margin-left: 5px;

    &:hover{
      text-decoration: underline;
    }
  }
}

@media only screen and (max-width: 430px) {
  .medium-3 {
    width: 50%;
    &.pax {
      padding-right: 5px;
    }
  }
  .p-L-10, .p-R-10 {
    padding: 0;
  }

  .m-B-10 {
    margin: 0;
  }

  .data-field {
    margin-bottom: 10px;
    padding: 0;

    textarea {
      min-height: 100px;
    }
  }

  .box {
    margin-top: 10px;
  }

  .service-types {
    margin: 0;
    margin-bottom: 10px;
  }

  .brand-box {
    .img-upload {
      padding: 0;
      display: flex;
      gap: 10px;
      margin-bottom: 15px;

      .inactive-image {
        margin-top: 0;
      }
      .img-box .recommened {
        line-height: unset;
      }
    }

    .sub-box {
      padding: 10px;
      margin: 0;
      margin-bottom: 10px;
      .heading {
        padding: 0;
      }
    }
  }

  .color-picker {
  width: 100%;
    .vc-photoshop {
        width: 100%;
      }
  }

  .disabled-list {
    column-count: 1;
    li {
      display: block;
      a {
        display: inline-block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Services/ServiceDetails.vue